<template>
  <div style="width: 100%; height: 100%" ref="mychart"></div>
</template>
<script>
import * as echarts from 'echarts'

export default {
  name: 'ChartsPie',
  props: {
    title: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  watch: {
    data() {
      this.initMyChart() // 重置图表
    }
  },
  mounted() {
    // this.initMyChart()
    setTimeout(() => {
      this.initMyChart()
      const resizeOb = new ResizeObserver((entries) => {
        for (const entry of entries) {
          echarts.getInstanceByDom(entry.target).resize()
        }
      })
      resizeOb.observe(this.$refs.mychart)
    })
  },
  methods: {
    initMyChart() {
      let mychart = echarts.getInstanceByDom(this.$refs.mychart)
      if (mychart == null) mychart = echarts.init(this.$refs.mychart)
      const legendData = this.data.map((item) => (item.name ? item.name : ''))
      // const radius = this.type === 'pie' ? '70%' : ['35%', '60%']
      const option = {
        // 标题
        title: {
          text: this.title,
          left: 'center',
          top: 15,
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        // 工具提示
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        // 图例说明
        legend: {
          show: true,
          // orient: 'vertical',
          x: 'center',
          top: 'bottom',
          itemWidth: 12,
          itemHeight: 10,
          itemGap: 5,
          data: legendData,
          formatter: ['{a|{name}}'].join('\n'),
          textStyle: {
            color: '#aaa',
            rich: {
              a: {
                width: 140,
                fontSize: 10,
                lineHeight: 12
                // backgroundColor: 'transparent'
              }
            }
          }
        },
        // 颜色配置
        color: [
          '#667eea',
          '#19be6b',
          '#ff9a9e',
          '#fbc2eb',
          '#96e6a1',
          '#d4fc79',
          '#84fab0',
          '#8fd3f4',
          '#fccb90',
          '#d57eeb',
          '#e0c3fc',
          '#cfd9df'
        ],
        // 类型配置
        series: [
          {
            itemStyle: {
              normal: {
                label: {
                  show: false,
                  fontSize: 14,
                  formatter: '{c} ({d}%)'
                },
                labelLine: {
                  show: true
                }
              }
            },
            name: '设备数量',
            // 类型配置
            type: 'pie',
            radius: ['34%', '56%'],
            center: ['50%', '45%'],
            // 数据配置
            data: this.data
          }
        ]
      }
      mychart.setOption(option)
    }
  }
}
</script>
